import { Eye } from 'lucide-react';
import { formatDate } from '../lib/dateUtils';

export function ReadOnlyBanner({ submittedAt }) {
    return (
        <div className="mb-6 p-4 bg-[#425A65]/5 rounded-xl border border-[#425A65]/15 flex items-center gap-3" data-testid="read-only-banner">
            <div className="w-9 h-9 bg-[#425A65]/10 rounded-lg flex items-center justify-center shrink-0">
                <Eye className="h-4 w-4 text-[#425A65]" />
            </div>
            <div>
                <p className="text-sm font-medium text-[#425A65]">Modo revisión</p>
                <p className="text-xs text-[#616E7C]">
                    Estás revisando un módulo completado. Tus respuestas están guardadas.
                    {submittedAt && ` Enviado: ${formatDate(submittedAt)}`}
                </p>
            </div>
        </div>
    );
}
